module.exports = __webpack_public_path__ + "static/img/paizhao.b642ec2d.png";